const setResumeCertificates = (certificates) => ({
    type: 'SET_RESUME_CERTIFICATES',
    certificates,
});

export default setResumeCertificates;
